import { stationMethods } from "@swa-ui/itinerary";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const ROUTE_STATIONS_SCHEMA_FIELD_NAMES = {
  ARRIVE: "destinationAirportCode",
  DEPART: "originationAirportCode",
};

export const getRouteStationsFormFieldsSchema = () => ({
  [ROUTE_STATIONS_SCHEMA_FIELD_NAMES.DEPART]: yup.lazy(() =>
    yup
      .string()
      .trim()
      .required(i18n("RouteStationsFormFields__ERROR_REQUIRED_DEPART"))
      .test(
        "ValidDepartureAirport",
        i18n("RouteStationsFormFields__ERROR_VALID_DEPART"),
        (originationAirportCode) => stationMethods.getStation(originationAirportCode) !== undefined
      )
      .label(i18n("RouteStationsFormFields__DEPART_LABEL").toLowerCase())
  ),
  [ROUTE_STATIONS_SCHEMA_FIELD_NAMES.ARRIVE]: yup.lazy(() =>
    yup
      .string()
      .trim()
      .required(i18n("RouteStationsFormFields__ERROR_REQUIRED_ARRIVE"))
      .test(
        "ValidArrivalAirport",
        i18n("RouteStationsFormFields__ERROR_VALID_ARRIVE"),
        (destinationAirportCode) => stationMethods.getStation(destinationAirportCode) !== undefined
      )
      .when(ROUTE_STATIONS_SCHEMA_FIELD_NAMES.DEPART, (originationAirportCode, arriveSchema) =>
        arriveSchema.test(
          "InvalidArrivalAirport",
          i18n("RouteStationsFormFields__ERROR_MATCHING"),
          (destinationAirportCode) => originationAirportCode !== destinationAirportCode
        )
      )
      .label(i18n("RouteStationsFormFields__ARRIVE_LABEL").toLowerCase())
  ),
});
